<footer class="footer">
  <div class="container">
    <div class="navbar navbar-expand-lg d-flex flex-md-column flex-lg-row">
      <ul class="navbar-nav navbar-collapse collapse">
        <li class="nav-item footer-item" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
          <a class="nav-link" routerLink="/external-links">LIENS UTILES</a>
        </li>
        <li class="nav-item footer-item">
          <a class="nav-link" href="#" (click)="download($event, 'Mentions-légales.pdf')">MENTIONS LÉGALES</a>
        </li>
        <li class="nav-item footer-item" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
          <a class="nav-link" routerLink="/tutorials">AIDE & TUTORIELS</a>
        </li>
      </ul>
      <span class="text-white ms-lg-auto footer-text"
        >Une démarche partenariale pilotée par la <a href="https://www.grandlyon.com">Métropole de Lyon</a></span
      >
    </div>
  </div>
</footer>
